module.exports = "/_next/static/images/header-cccc5e9d487980b9d75da4daf9ff015e.jpg";